var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('full-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],key:"loading",attrs:{"id":"FullLoading"}}),(!_vm.isMobile)?_c('Menus'):_vm._e(),_c('keep-alive',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }